import * as React from 'react';
import { useWindowSizeContext } from './hooks';
import { IWindowSizeProps } from './types';

export function withWindowSize<TProps extends IWindowSizeProps>(Component: React.ComponentType<TProps>) {
    const WithWindowSize = React.memo((props: Omit<TProps, keyof IWindowSizeProps>) => {
        const size = useWindowSizeContext();
        return (
            <Component {...props as TProps} {...size} />
        );
    });
    WithWindowSize.displayName = 'WithWindowSize';
    return WithWindowSize;
}
